module.exports = __webpack_public_path__ + "img/thumbnail-header-17.07dfd34.png";